import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, DollarSign, Flame } from "lucide-react";
import { CATEGORY_META, timeAgo } from "../lib/api";

export default function TaskCard({ task, index = 0 }) {
  const meta = CATEGORY_META[task.category] || { label: task.category, className: "" };
  return (
    <Link
      to={`/task/${task.id}`}
      data-testid={`task-card-${task.id}`}
      className="brut-card brut-card-hover block p-5 slide-up"
      style={{ animationDelay: `${Math.min(index, 8) * 50}ms` }}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <span className={`brut-chip ${meta.className}`}>{meta.label}</span>
        <div className="text-right">
          <div className="font-display tabular text-3xl font-black leading-none text-[var(--cs-ink)]">
            <span className="text-[var(--cs-money-2)]">$</span>
            {Math.round(task.price)}
          </div>
        </div>
      </div>
      <h3 className="font-display text-xl font-extrabold leading-tight mb-2">
        {task.title}
      </h3>
      <p className="text-sm text-[var(--cs-ink-2)] line-clamp-2 mb-4">
        {task.description}
      </p>
      <div className="flex items-center gap-4 text-xs font-semibold text-[var(--cs-ink-2)]">
        <span className="inline-flex items-center gap-1">
          <MapPin size={13} />
          <span className="tabular">{task.distance_miles}mi</span> · {task.location_text}
        </span>
      </div>
      <div className="mt-3 flex items-center justify-between">
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-[var(--cs-ink-2)]">
          <Clock size={13} /> {task.time_window}
        </span>
        <span className="text-[11px] uppercase tracking-wider font-bold text-[var(--cs-ink-2)]">
          {timeAgo(task.created_at)}
        </span>
      </div>
    </Link>
  );
}
